import { FC } from 'react';

import LShapeNorth from '../../../../../../../assets/icons/shapes/l-shape/l-shape-1.svg?react';
import LShapeEast from '../../../../../../../assets/icons/shapes/l-shape/l-shape-2.svg?react';
import LShapeSouth from '../../../../../../../assets/icons/shapes/l-shape/l-shape-3.svg?react';
import LShapeWest from '../../../../../../../assets/icons/shapes/l-shape/l-shape-4.svg?react';
import { Himmelretning } from '../../../../../utils/registerEnums';

import { ShapeProps } from './types';

export const LShape: FC<ShapeProps> = ({ direction }) => {
  switch (direction) {
    case Himmelretning.Nord:
      return <LShapeNorth />;
    case Himmelretning.Ost:
      return <LShapeEast />;
    case Himmelretning.Sor:
      return <LShapeSouth />;
    case Himmelretning.Vest:
      return <LShapeWest />;

    default:
      return <LShapeNorth />;
  }
};
